import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';

function SearchProgressModalFooter(props) {
  const { cancelSearch } = props;

  return (
    <div className="search-modal__footer" data-testid="search-modal-footer">
      <ButtonWithIcon
        data-e2e="modal-search-cancel"
        name="cancel-search"
        type="link"
        size="small"
        linkIconSize="s"
        sprite="Close"
        iconRight
        onClick={cancelSearch}
        className="e2e-modal-search-cancel">
        Cancel
      </ButtonWithIcon>
    </div>
  );
}

SearchProgressModalFooter.propTypes = {
  cancelSearch: PropTypes.func.isRequired,
};

export default SearchProgressModalFooter;
